import React from 'react';
import styled from 'styled-components';

export const H1 = styled.h1`
  color: var(--header-text-color);
  display: block;
  font-family: 'secondarytypeface', 'Georgia', serif;
  font-size: 2.8em;
  font-weight: normal;
  line-height: 1.25;
  margin: 0 0 30px;
  text-align: ${p => p.align || 'left'};
`;
